import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../redux/actions/uxActions';
import store from '../redux/store';
import { Window } from '../utils/window';

function useTranslations() {
  const dispatch = useDispatch();
  const { texts } = store.getState().auth.whitelabel;
  const storeLanguageKey = useSelector((store) => store.ux.language);

  // Priorizar el valor de localStorage
  const storedLanguage = Window()?.localStorage.getItem('language');
  const languageKey = storedLanguage || storeLanguageKey || 'es';

  const changeLanguageKey = (key) => {
    dispatch(setLanguage(key));
    Window()?.localStorage.setItem('language', key);
  };

  useEffect(() => {
    // Al montar, sincronizar con localStorage si es necesario
    if (storedLanguage && storedLanguage !== storeLanguageKey) {
      dispatch(setLanguage(storedLanguage));
    } else if (!storedLanguage && storeLanguageKey) {
      // Si no hay idioma guardado, guardar el actual
      Window()?.localStorage.setItem('language', storeLanguageKey);
    }
  }, []);

  return {
    key: languageKey,
    texts: texts ? texts[languageKey] : null,
    changeLanguageKey,
  };
}

export default useTranslations;
